var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessBrEllips({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 290,
    viewBox: "0 0 252 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 188.152,
    cy: 261.847,
    r: 186.653,
    transform: "rotate(-180 188.152 261.847)",
    stroke: "#FF5349",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 243.815,
    cy: 148.955,
    r: 146.955,
    transform: "rotate(-180 243.815 148.955)",
    stroke: "#FF5349",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBrEllips);
export default __webpack_public_path__ + "static/media/success-br-ellips.99d8f849ed51f0d0850f205749395cfe.svg";
export { ForwardRef as ReactComponent };